var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"faleConosco"}},[_c('Banner',{attrs:{"contents":_vm.banner}}),_c('Cards')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }